import logo from "@assets/tournaments/coramprof/logo.png";
import escudo from "@assets/tournaments/coramprof/escudo.webp";
import coramprofRules from "./lineupRules/coramprof";

const coramprof = {
  id: "coramprof",
  name: "Copa Amistad Profesional - CorAmProf",
  logo,
  escudo,
  gaId: "G-JDKGC9DGSG",
  footerLinks: [
    {
      label: "Documentos Dian",
      icon: "icon-pdf",
      href: "https://coramprof.com/dian",
    },
    {
      label: "Estadísticas",
      icon: "icon-users",
      href: "https://coramprof.com/statistics",
    },
  ],
  // Bandas de edad del carnet, con las claves que envía el backend en `media`.
  ageBands: {
    // De menor a mayor edad; define el orden de las listas de jugadores.
    order: ["goalkeeper", "young", "middle", "old", "old_middle", "too_old"],
    // Fondo del jugador en la cancha (componente Lineups).
    lineupColors: {
      too_old: "#a52a2a",
      old_middle: "#898787",
      old: "#008000",
      middle: "#0000ff",
      young: "#ff0000",
      default: "#ffff00",
    },
    // Borde del avatar en las filas de jugadores.
    avatarColors: {
      young: "var(--red)",
      too_old: "var(--orange)",
      middle: "var(--blue)",
      old: "var(--green)",
      goalkeeper: "var(--accent)",
      old_middle: "var(--text-light)",
    },
    // Nombre, rango de edad y color de texto de cada carnet (tablero del delegado).
    // El color de fondo es el de avatarColors.
    carnets: {
      goalkeeper: { label: "Arquero", short: "ARQ", text: "#111" },
      young: { label: "Rojo", short: "32-34", text: "#fff" },
      middle: { label: "Azul", short: "35-39", text: "#fff" },
      old: { label: "Verde", short: "40-44", text: "#fff" },
      old_middle: { label: "Gris", short: "45-49", text: "#111" },
      too_old: { label: "Marrón", short: "50+", text: "#fff" },
    },
  },
  // Rutas del backend de este torneo que difieren entre APIs.
  api: {
    // Eventos del partido que consumen TeamsLineups y TeamCompare.
    lineupEventsPath: "event/byGameTotal",
  },
  // Pantalla del día del partido (TeamsLineupsDay).
  matchDay: {
    attendanceTitle: "Asistencia",
    // En finales (typestage 2) se listan todos los jugadores.
    onlyAttendedInFinals: false,
    // Máximo de jugadores en cancha por equipo (no se puede forzar).
    maxOnField: 11,
    // Estados del partido en los que se puede remover a un titular.
    starterRemovableStatuses: [1],
    // Qué hace tocar a un jugador de la lista de asistencia:
    // "events" abre sus eventos, "removeStarter"/"removeAttendance" piden confirmación.
    attendanceAction: (match) =>
      match && match.gamestatuscode === 1
        ? "removeStarter"
        : match && (match.gamestatuscode === 2 || match.gamestatuscode === 6)
        ? "events"
        : "removeAttendance",
  },
  // Vista pública del partido (TeamsLineups).
  lineupView: {
    showAttendanceList: true,
    hideDismissedFromField: true,
  },
  // Pantalla "Mi Equipo" (/players-sumary, rol club): si el club puede
  // inscribir jugadores nuevos y editar los existentes (datos y foto).
  // En false los botones quedan deshabilitados; el backend no lo valida.
  playerManagement: {
    allowCreate: false,
    allowEdit: false,
  },
  // Portada: diseño (layouts.js), widgets en orden de aparición y reglas de partidos.
  home: {
    // Cabecera de la portada (LeagueHero); se le agrega el año actual al subtítulo.
    hero: { title: "Copa Amistad Profesional", subtitle: "CorAmProf" },
    layout: "home_compact",
    widgets: ["champions", "team_stats", "month_matches", "live_report"],
    // Últimos resultados y en vivo.
    recentGames: {
      statuses: [2, 5, 6, 7],
    },
    // Próximos partidos (sin aplazados).
    upcomingGames: {
      statuses: [1, 4],
    },
  },
  // Reglamento de LINEUPS (ingreso, sustitución, presencia).
  lineupRules: coramprofRules,
  // Título de la página de estadísticas del torneo en curso (los anteriores salen de game/championshipold).
  statistics: {
    currentTitle: "Estadísticas torneo 2026-1",
  },
  support: {
    whatsappUrl: "https://wa.link/oetmo8",
  },
  // Documentos de la página DIAN: lista plana en orden de aparición; `file` es relativo a REACT_APP_URL_BK.
  dianDocuments: [
    {
      name: "RUT",
      detail: "R.U.T",
      file: "static/rut_cap.pdf",
    },
    {
      name: "Estados Financieros 2025",
      detail: "Estados Financieros 2025",
      file: "static/financieros.pdf",
    },
    {
      name: "Acta 14-2026",
      detail: "Acta 14-2026",
      file: "static/acta.pdf",
    },
    {
      name: "Informe Anual de Gestión",
      detail: "Informe Anual de Gestión",
      file: "static/informe.pdf",
    },
    {
      name: "Formulario DIAN ESAL",
      detail: "Formulario DIAN ESAL",
      file: "static/esal.pdf",
    },
  ],
  // Página Fase final (llave de eliminatorias, src/bracket + widgets/FinalBracket).
  bracket: {
    title: "Cuadro Final Torneo Apertura",
    backLink: { label: "Ver Estadísticas Primera Fase", to: "/historial" },
    // Nombre del equipo comodín que ocupa los cupos aún sin definir (y el rival de un bye).
    placeholderTeamName: "Por definir",
  },
  // Sin formatosDocuments ni nosotrosDocuments: CORAMPROF no tiene las páginas Formatos y Nosotros.
  // Códigos de campeonato del backend de este torneo.
  championships: {
    actual: 7, // campeonato en curso
    staff: 1, // campeonato donde se registran árbitros/asistentes (equipos 5 y 6)
    transfer: 4, // campeonato usado al crear jugadores por traspaso
  },
};

export default coramprof;
